__turbopack_context__.v({
  "container": "_0ma0TG_container",
  "content": "_0ma0TG_content",
  "mobileMenu": "_0ma0TG_mobileMenu",
  "mobileMenuContainer": "_0ma0TG_mobileMenuContainer",
  "mobileMenuIcon": "_0ma0TG_mobileMenuIcon",
  "mobileMenuToggle": "_0ma0TG_mobileMenuToggle",
  "showcaseTemplateContainer": "_0ma0TG_showcaseTemplateContainer",
  "sidebarContainer": "_0ma0TG_sidebarContainer",
  "templatesContainer": "_0ma0TG_templatesContainer",
});
